/**
 * Format a number as Indian Rupees.
 * @param {number} amount
 * @returns {string}
 */
export const formatINR = (amount) =>
  `₹${amount.toLocaleString('en-IN')}`

/**
 * Calculate savings amount.
 * @param {number} original
 * @param {number} discounted
 * @returns {number}
 */
export const calcSavings = (original, discounted) => original - discounted

/**
 * Return a Tailwind gradient class based on discount percentage.
 * @param {number} percent
 * @returns {string}
 */
export const discountBadgeGradient = (percent) => {
  if (percent >= 60) return 'from-rose-600 to-red-500'
  if (percent >= 40) return 'from-orange-500 to-amber-400'
  return 'from-emerald-600 to-green-500'
}
